module.exports = __webpack_public_path__ + "img/coins-instructions-illustration.899a5d45.svg";